<template>
  <div class="app">
	<!-- <heads :title="title" type="2"></heads> -->
	<div class="content">
		<van-empty v-if="list.length == 0" description="暂无数据" />
		<div v-else class="news-card" v-for="item in list" @click="goPage(item)">
			<div class="u-flex-col justify-between" style="height: 100%; flex: 1;">
				<div class="flxx">
				<span class="theme u-line-3">{{item.title}}</span>
				</div>
				<div class="justify-between" style="display: flex; align-items: center; margin-top: 8px">
				<span class="dz">{{item.eventType_dictText}}</span>
				<span class="time">{{item.createTime}}</span>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker } from 'vant'
export default {
	data(){
		return{
			text:"/hmhq/wallDetail",
			list:[],
			loading: false,
			finished: false,
			refreshing: false,
			pageNo:0,
		}
	},
	mounted() {
		this.init()
	},
	methods:{
		init(){
			let openId = this.$store.getters.openId;
      		let params = {pageNo:this.pageNo,openId:openId};
			getAction('/zhshj/zzgzhblssh/pageForGzh',params)
			.then((res)=>{
				this.loading = false;
				this.finished = true;
				let data = res.result.records
				this.list = data
			})
		},
		goPage(e){
			this.$router.push({
				name:"hbls-view",
				params:{
					type:1,
					id:e.id
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	height: 100vh;
	background-color: #f6f7f9;
}
p{
	margin: 0px;
	padding: 0px;
}
input{
	border: none
}

.news-card {
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  display: flex;
  padding: 12px 10px;
  position: relative;

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .flxx{
    display: flex;
    align-items: center;
  }
  .ry{
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
  .img {
    width: 64px;
    height: 64px;
    margin-right: 10px;
  }

  .theme {
    font-size: 15px;
    font-weight: 400;
    color: #303133;
  }

  .time {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
    margin-left: auto;
  }

  .dz {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
}

	.jiaobiao{width: 80px; height: 80px; background: #99adc2; color: #fff; display: flex; align-items: flex-end; transform: rotate(45deg); -webkit-transform: rotate(45deg); position: absolute; font-size: 12px; top: -48px; right: -48px; justify-content: center;}
	.jiaobiao font{position: relative; top: 2px; letter-spacing: 1px;}
</style>